import Register from "../components/Register/index";

function init() {
  return <Register />;
}

export default init;
